/*
 * Services shown in the "Understand your options" section and in the "Explore a service" modal.
 * `summary` appears on the card; `description` and `points` appear in the modal.
 * `formOption` is the matching choice in the contact form's "Service of interest" dropdown.
 */
export const NOT_SURE_OPTION = 'I’m not sure';

const services = [
    {
        slug: 'therapy',
        title: 'Individual & group therapy',
        formOption: 'Individual & group therapy',
        summary: 'A place to work through difficult feelings, relationships, stress, and life changes.',
        description: 'Therapy offers a supportive space to talk, identify patterns, and build coping skills. Individual sessions focus on your needs; group sessions offer a chance to learn with others.',
        points: [
            'Explore concerns such as anxiety, low mood, and stress.',
            'Discuss goals and the approach that fits you.',
            'Ask intake about current individual and group availability.',
        ],
    },
    {
        slug: 'psychiatric-care',
        title: 'Psychiatric care',
        formOption: 'Psychiatric care',
        summary: 'Understand your symptoms and discuss appropriate treatment options with a psychiatric provider.',
        description: 'A psychiatric evaluation helps a provider understand your symptoms, history, and treatment needs. If medication services are available and appropriate, discuss benefits, questions, and follow-up needs together.',
        points: [
            'Ask about evaluations and provider availability.',
            'Confirm whether ongoing medication management is offered.',
            'Share clinical history through the secure intake process.',
        ],
    },
    {
        slug: 'prp',
        title: 'Psychiatric rehabilitation (PRP)',
        formOption: 'Psychiatric rehabilitation (PRP)',
        summary: 'Build practical skills, daily routines, and confidence in everyday life alongside your treatment.',
        description: 'PRP supports eligible people whose emotional and behavioral challenges affect daily functioning. Rehabilitation support may focus on routines, community connections, and skills for greater independence.',
        points: [
            'Work toward practical, individualized rehabilitation goals.',
            'PRP complements clinical treatment.',
            'Confirm eligibility and licensed-provider referral requirements.',
        ],
    },
    {
        slug: 'children-adolescents',
        title: 'Children & adolescent support',
        formOption: 'Children & adolescent support',
        summary: 'Support that considers a young person’s emotions, development, family, and daily environment.',
        description: 'Youth services consider the young person’s needs and the role of caregivers. Intake can explain available programs, age ranges, and how a parent or guardian participates.',
        points: [
            'Ask about age-appropriate therapy options.',
            'Confirm caregiver involvement and consent requirements.',
            'Discuss school or family coordination if available.',
        ],
    },
    {
        slug: 'substance-use',
        title: 'Substance use & recovery',
        formOption: 'Substance use & recovery',
        summary: 'Explore support for substance-related concerns and the next steps toward recovery.',
        // The demo's body text for this card is an internal note to the clinic, so a client-facing line is used here.
        description: 'Outpatient support for alcohol or drug concerns, with emotional wellness and recovery needs addressed together. Intake can explain the active treatment programs and how care is coordinated.',
        points: [
            'Discuss currently available assessments and treatment.',
            'Confirm whether medication-assisted treatment support is offered.',
            'Ask how emotional wellness and recovery needs are coordinated.',
        ],
    },
    {
        slug: 'not-sure',
        title: 'Not sure where to begin?',
        formOption: NOT_SURE_OPTION,
        summary: 'You do not need a diagnosis or the perfect words to ask about your options.',
        description: 'Start by contacting intake. The team can explain available services, ask a few initial questions, and help you understand a suitable next step.',
        points: [
            'Choose “I’m not sure” on the request form.',
            'Ask about insurance and appointment formats.',
            'Keep detailed health information out of the website form.',
        ],
    },
];

export default services;
